"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _APSelect = _interopRequireDefault(require("../../common/APSelect"));
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
var _formTemplateHelper = require("../../../helpers/formTemplateHelper");
var _Spinner = _interopRequireDefault(require("../../common/Spinner/Spinner"));
var _config = _interopRequireDefault(require("../../../config"));
require("./SendAddress.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var baseClasses = (0, _cssClassesHelper.getBEMClasses)('send-address');
var SendAddressComponent = /*#__PURE__*/function (_React$Component) {
  function SendAddressComponent() {
    var _this;
    _classCallCheck(this, SendAddressComponent);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, SendAddressComponent, [].concat(args));
    _defineProperty(_this, "getProductData", function () {
      var _this$props = _this.props,
        selectWithdrawProduct = _this$props.selectWithdrawProduct,
        ProductId = _this$props.product.ProductId;
      selectWithdrawProduct(ProductId);
    });
    return _this;
  }
  _inherits(SendAddressComponent, _React$Component);
  return _createClass(SendAddressComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.getProductData();
    }
  }, {
    key: "render",
    value: function render() {
      var t = this.props.t;
      var _this$props2 = this.props,
        withdrawInfo = _this$props2.withdrawInfo,
        template = _this$props2.withdrawInfo.template,
        product = _this$props2.product,
        ProductId = _this$props2.product.ProductId,
        selectWithdrawTemplate = _this$props2.selectWithdrawTemplate,
        WalletsDisabledMessage = _this$props2.WalletsDisabledMessage,
        verificationLevelConfig = _this$props2.verificationLevelConfig;
      var showTemplateFields = Object.keys(template || {}).length;
      var showTemplateTypeSelect = withdrawInfo.templateTypes.length > 1 && !Object.keys(withdrawInfo.templateInfo).length && !withdrawInfo.isLoading;
      var templateTypes = [{
        value: '',
        label: 'Select an option'
      }].concat(_toConsumableArray(withdrawInfo.templateTypes.map(function (template) {
        return {
          value: template.AccountProviderId,
          label: template[_config["default"].Withdraw.AccountProviderDisplayKey]
        };
      })));
      var hasError = withdrawInfo.error || WalletsDisabledMessage;
      return /*#__PURE__*/_react["default"].createElement("div", null, withdrawInfo.withdrawStatus.success ? /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('success')
      }, t('Your withdraw ticket was created successfully.')) : /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('form-body')
      }, hasError ? /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('error')
      }, hasError) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, withdrawInfo.isLoading && /*#__PURE__*/_react["default"].createElement(_Spinner["default"], null), showTemplateTypeSelect && /*#__PURE__*/_react["default"].createElement(_APSelect["default"], {
        name: "TemplateType",
        customClass: baseClasses(),
        label: t('Select an option to continue the withdraw process'),
        onSelect: function onSelect(value) {
          return selectWithdrawTemplate(ProductId, value);
        },
        options: templateTypes
      }), showTemplateFields > 0 && /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('section')
      }, (0, _formTemplateHelper.templateFormRenderer)(template, baseClasses(), {
        t: t
      }, product, verificationLevelConfig)))));
    }
  }]);
}(_react["default"].Component);
SendAddressComponent.defaultProps = {
  withdrawInfo: {
    templateInfo: {},
    template: {},
    isLoading: false,
    error: '',
    TemplateForm: {},
    withdrawStatus: {},
    getWithdrawFee: function getWithdrawFee() {}
  }
};
SendAddressComponent.propTypes = {
  getWithdrawFee: _propTypes["default"].func,
  selectWithdrawProduct: _propTypes["default"].func.isRequired,
  product: _propTypes["default"].shape({
    ProductSymbol: _propTypes["default"].string,
    ProductId: _propTypes["default"].number
  }).isRequired,
  withdrawInfo: _propTypes["default"].shape({
    templateInfo: _propTypes["default"].object.isRequired,
    template: _propTypes["default"].object.isRequired,
    isLoading: _propTypes["default"].bool.isRequired,
    error: _propTypes["default"].string.isRequired,
    TemplateForm: _propTypes["default"].oneOfType([_propTypes["default"].array, _propTypes["default"].object]),
    withdrawStatus: _propTypes["default"].shape({
      success: _propTypes["default"].bool,
      RequestCode: _propTypes["default"].string
    }).isRequired
  })
};
var _default = exports["default"] = (0, _reactI18next.withTranslation)('send')(SendAddressComponent);